<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import { inquiryScheduleTaskInstance, getTaskTypeList, saveOrUpdateInstance, scheduletaskget, switchStatus } from '../../../../../api/home.js';
import { title } from 'process';
export default {
	name: 'ScheduledTasks',
	data() {
		return {
			/* 表格 */
			pagination: getdata().pagination,
			headData: JSON.parse(localStorage.getItem('ScheduledTasksheadData')) || getdata().headData,
			outlist: JSON.parse(localStorage.getItem('ScheduledTasksoutlist')) || [],
			shaidiag: false,
			tableData: [],
			tablekey: 0,
			title: '',
			Roletk: false,
			formlist: getdata().formlist,
			formdata: getdata().formdata,
			implementation: [], //实例名称对象
			status: '0', //状态
			id: '-1', //id
			Count: 0
		};
	},
	mounted() {},
	created() {
		this.searrchForData();
	},
	methods: {
		//表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			localStorage.setItem('ScheduledTasksoutlist', JSON.stringify(e.nochooselist));
			localStorage.setItem('ScheduledTasksheadData', JSON.stringify(e.chooselist));
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
			this.getCloseoutPageList();
		},
		selectionchange(e) {
			this.Count = e.length;
		},
		//启动停用切换
		Startingstopping(ids, enable) {
			let params = { ids: ids, enable: enable };
			switchStatus(params).then(res => {
				if (res.data.code == '200') {
					this.$message.success('操作成功');
					this.searrchForData();
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		//新建按钮
		Roletkhq() {
			this.title = '新建定时任务';
			getTaskTypeList().then(res => {
				if (res.data.code == '200') {
					this.formlist[0].selectval = res.data.data.map(v => {
						return {
							label: v.key,
							value: v.value
						};
					});
					this.formdata.implementation = '';
					this.formdata.name = '';
					this.formdata.cron = '';
					this.id = '-1';
					this.status = '';
					this.Roletk = true;
					this.$nextTick(() => {
						this.$refs['taxform'].clearValidate();
					});
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		//页面初始化查询
		searrchForData() {
			let params = { page: this.pagination.pageNum, rows: this.pagination.pageSize, sort: '', order: '' };
			inquiryScheduleTaskInstance(params).then(res => {
				if (res.data.code == '200') {
					this.tableData = res.data.data;
					this.pagination.total = res.data.count;
					getTaskTypeList().then(res => {
						if (res.data.code == '200') {
							this.implementation = res.data.data;
						}
					});
				}
			});
		},
		//form表单验证通过后保存
		getdata() {
			var parser = require('cron-parser');
			try {
				var interval = parser.parseExpression(this.formdata.cron);
				if (/^[0-9]+$/.test(this.formdata.cron)) {
					this.$message.error('定时参数: 格式错误-' + this.formdata.cron);
				} else {
					let params = { id: this.id, status: this.status, implementation: this.formdata.implementation, name: this.formdata.name, cron: this.formdata.cron };
					saveOrUpdateInstance(params).then(res => {
						if (res.data.code == '200') {
							this.$message.success('保存成功');
							this.searrchForData();
							this.Roletk = false;
						} else {
							this.$message.error(res.data.message);
						}
					});
				}
			} catch (err) {
				this.$message.error('定时参数: 格式错误-' + this.formdata.cron);
			}
		},
		//保存和保存并启用按钮
		preserve(v) {
			if (this.id == '-1' || v != 0) {
				this.status = v;
			}
			this.$refs.taxform.submitForm();
		},
		//编辑按钮
		compile(id) {
			this.title = '编辑定时任务';
			getTaskTypeList().then(res => {
				if (res.data.code == '200') {
					this.formlist[0].selectval = res.data.data.map(v => {
						return {
							label: v.key,
							value: v.value
						};
					});
					let params = { id: id };
					scheduletaskget(params).then(res => {
						if (res.data.code == '200') {
							this.formdata = res.data.data;
							this.formdata.implementation = res.data.data.implementation;
							this.formdata.name = res.data.data.name;
							this.formdata.cron = res.data.data.cron;
							this.id = id;
							this.status = res.data.data.status;
							this.Roletk = true;
							this.$nextTick(() => {
								this.$refs['taxform'].clearValidate();
							});
						} else {
							this.$message.error(res.data.message);
						}
					});
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		/* 表格 */
		currentChange(e) {
			this.pagination.pageNum = e;
			this.searrchForData();
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.searrchForData();
		}
		/* 表格 */
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
